import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/client/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
